// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "" + {"2863":"css/inline-layout/inline-layout","6938":"css/style","7628":"css/libs"}[chunkId] + ".css";
};